import styled from 'styled-components'

export const CHART_HEIGHT = 440

export default styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')} !important;
  flex: 1 1 auto;
  /* must be set in pixels for tradingview, unfortunately. */
  flex-basis: ${({ hidden, fullScreen }) => (!hidden && fullScreen ? '95%' : `${CHART_HEIGHT}px`)};
  height: 100%;
  outline: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
  & .showHand {
    cursor: auto !important;
  }
  & canvas {
    position: absolute;
    user-select: none;
  }
  & .tradingview-widget-container {
    &,
    & > div {
      bottom: 0;
      height: 100%;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
`
